const globalObj = globalThis as {
  process?: {
    env?: Record<string, unknown>
    versions?: Record<string, unknown>
  }
}

if (!globalObj.process) globalObj.process = {}
if (!globalObj.process.env) globalObj.process.env = {}
if (!globalObj.process.versions) globalObj.process.versions = {}
